module.exports = __webpack_public_path__ + "img/bg-image-20.88c5a855.jpg";